module.exports = require("./fr-SN.d.ts");